import { useState } from "react";
import { tickerItems } from "@/mocks/mayiBaoliao";

const navLinks = [
  { href: "#hot", label: "今日热榜" },
  { href: "#live", label: "实况快讯" },
  { href: "#guides", label: "五大方向" },
  { href: "#checklist", label: "避坑清单" },
  { href: "#board", label: "数据小报" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loop = [...tickerItems, ...tickerItems];

  return (
    <>
      {/* 更新条压顶 */}
      <div className="w-full bg-foreground-950 text-background-100">
        <div className="flex items-stretch px-4 md:px-6">
          <div className="flex shrink-0 items-center gap-2 py-2 pr-3 text-xs">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="blink-dot absolute h-2 w-2 rounded-full bg-accent-400" />
            </span>
            <span className="font-semibold tracking-wide text-background-50">实况滚动</span>
          </div>
          <div className="relative flex h-9 flex-1 items-center overflow-hidden border-l border-foreground-700 pl-3">
            <div className="tick-track flex w-max items-center gap-10 whitespace-nowrap text-xs text-foreground-200">
              {loop.map((t, i) => (
                <span key={i} className="flex items-center gap-2">
                  <i className="ri-record-circle-line text-[10px] text-primary-400" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
        <div className="flex items-center justify-between gap-4 px-4 py-3 md:px-6">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500">
              <i className="ri-sparkling-2-line text-lg text-background-50" />
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">五一爆料</span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="rounded-md px-3 py-1.5 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-foreground-950"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#live"
              className="ml-2 whitespace-nowrap rounded-full bg-accent-500 px-4 py-1.5 text-sm font-semibold text-background-50 transition hover:bg-accent-600"
            >
              订阅提醒
            </a>
          </nav>

          <button
            type="button"
            aria-label="菜单"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-900 md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>

        {open && (
          <div className="flex flex-col gap-1 border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#live"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-accent-500 px-3 py-2 text-center text-sm font-semibold text-background-50"
            >
              订阅提醒
            </a>
          </div>
        )}
      </header>
    </>
  );
}